import { useEffect } from 'react';

import { useEffectOnce } from 'react-use';

import { useSession } from '@/providers/SessionProvider/SessionProvider';

import { InitAppCuesIdentify, setupLaunchPadStyling } from './appcues';

const InitAppCues = () => {
  const { currentUser, currentClient } = useSession();

  const isProduction = import.meta.env.MODE === 'production';

  // One-time setup for Appcues styling
  useEffectOnce(() => {
    if (!isProduction) return;

    setupLaunchPadStyling();
  });

  useEffect(() => {
    if (!isProduction || !currentUser?.id || !currentClient?.id) return;

    InitAppCuesIdentify(currentUser, currentClient);

    // Only track client ID changes - user changes don't require re-identification
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id]);

  return null;
};

export default InitAppCues;
